// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hotel-gallery[data-v-e58202ae]{height:12rem}@media (min-width:640px){.hotel-gallery[data-v-e58202ae]{height:14rem}}@media (min-width:768px){.hotel-gallery[data-v-e58202ae]{height:26rem}}@media (min-width:1024px){.hotel-gallery[data-v-e58202ae]{height:12rem}}@media (min-width:1280px){.hotel-gallery[data-v-e58202ae]{height:14rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
